(function(window, document, $) {
	var $win = $(window);
	var $doc = $(document);
	var $body = $("body");
	var scrolledY = 0;
	var scrollOnOpen = null;
	function removeMessages() {
		$(".widget-cart .woocommerce-notices-wrapper").html("");
	}
	function isMobile() {
		return $win.width() < 767;
	}
	//Animate Sections
	var $animated = $(".animated");
	var winHeight = $win.height();
	var winWidth = $win.width();
	var winScroll = $win.scrollTop();
	function animateElements() {
		winScroll = $win.scrollTop();
		if ($animated.length === 0) {
			return;
		}
	}
	function animate(winST) {
		$(".animate").each(function() {
			var $this = $(this);
			if (winST + $win.outerHeight() / 1.2 > $this.offset().top) {
				$this.addClass("animated");
			} else if (winST + $win.outerHeight() / 2 < $this.offset().top) {
				$this.removeClass("animated");
			}
		});
	}
	function initProducts() {
		$(".product-secondary").on("click", function(e) {
			e.preventDefault();
			if ($win.width() > 767) {
				$(this)
					.addClass("expanded")
					.closest(".form__col")
					.siblings()
					.find(".product-secondary")
					.removeClass("expanded");
			}
		});
		$doc.on("click touchstart", function(e) {
			var $target = $(e.target);
			if (!$target.closest(".product-secondary").length) {
				$(".product-secondary").removeClass("expanded");
			}
		});
	}
	google.maps.Map.prototype.setCenterWithOffset = function(
		latlng,
		offsetX,
		offsetY
	) {
		var map = this;
		var ov = new google.maps.OverlayView();
		ov.onAdd = function() {
			var proj = this.getProjection();
			var aPoint = proj.fromLatLngToContainerPixel(latlng);
			aPoint.x = aPoint.x + offsetX;
			aPoint.y = aPoint.y + offsetY;
			map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
		};
		ov.draw = function() {};
		ov.setMap(this);
	};
	function getInfoBoxYoffset($map) {
		var mapHeight = $map.outerHeight();
		var infoBoxHeight = $map.find(".infoBox").outerHeight();
		return -1 * ((infoBoxHeight + 40) / 2);
	}
	// Function to initialize maps
	function startMaps() {
		$('[id^="map"]').each(function() {
			var content;
			var iBox;
			var $map = $(this);
			var mapData = $map.data("source");
			var markers = [];
			var markersLength = mapData.markers.length;
			var clusterIsEnabled = mapData.cluster;
			var clusterOptions = {
				styles: [
					{
						fontWeight: "normal",
						fontFamily: "Roboto, sans-serif",
						textColor: "white",
						height: 34,
						url: "assets/images/marker.png",
						width: 24,
						textSize: 1,
					},
				],
			};
			var mapOptions = {
				center: {
					lat: 32.7190126,
					lng: -117.170133,
				},
				zoom: 13,
				minZoom: 5,
				mapTypeControl: false,
				styles: [
					{
						featureType: "all",
						elementType: "all",
						stylers: [
							{
								saturation: -100,
							},
						],
					},
				],
			};
			var bounds = new google.maps.LatLngBounds();
			var map = new google.maps.Map($map.get(0), mapOptions);
			map.addListener("click", function(event) {
				iBox.close();
				for (var i = 0; i < markers.length; i++) {
					markers[i].iBoxOpen = false;
				}
			});
			for (var i = 0; i < markersLength; i++) {
				var marker;
				content =
					'<div class="infobox"><div class="infobox__body"><h6>' +
					mapData.markers[i].infobox.title +
					"</h6><p>" +
					mapData.markers[i].infobox.text +
					'<br><a href="tel:' +
					mapData.markers[i].infobox.link +
					'">' +
					mapData.markers[i].infobox.link +
					'</a></p><img src=" ' +
					mapData.markers[i].icon +
					'" alt="" class="infobox__marker" /></div>';
				marker = new google.maps.Marker({
					position: new google.maps.LatLng(
						mapData.markers[i].position
					),
					map: map,
					content: content,
					iBoxOpen: false,
					icon: mapData.markers[i].icon,
				});
				var boundsPos = new google.maps.LatLng(
					mapData.markers[i].position.lat,
					mapData.markers[i].position.lng
				);
				bounds.extend(boundsPos);
				iBox = new InfoBox();
				marker.addListener("click", function() {
					iBox.close();
					for (var i = 0; i < markers.length; i++) {
						markers[i].iBoxOpen = false;
					}
					if (this.iBoxOpen == false) {
						iBox.setContent(this.content);
						iBox.open(map, this);
						this.iBoxOpen = true;
					}
					if ($win.width() < 1200) {
						var pos = this.position;
						setTimeout(function() {
							map.setCenterWithOffset(
								pos,
								0,
								getInfoBoxYoffset($map)
							);
						}, 500);
					}
				});
				markers.push(marker);
			}
			if ($win.width() < 1200) {
				map.setCenterWithOffset(
					markers[0].position,
					0,
					getInfoBoxYoffset($map)
				);
			}
			map.fitBounds(bounds);
		});
	}

	function set_product_variation_image(variation_slug) {
		if ( $('.variation__image').length ) {
			$('.variation__image').addClass('hidden');
			$('.variation__image.' + variation_slug).removeClass('hidden');
		}
	}

	$doc.on("click", ".js-popup", function(e) {
		e.preventDefault();
		var fragment = $(this).data("fragment");
		var product = $(this).data("product");
		$.ajax({
			url: crb_options.admin_ajax_url,
			type: "GET",
			data: {
				action: "open_popup",
				fragment: fragment,
				product: product,
			},
			success: function(result) {
				$.magnificPopup.open({
					removalDelay: 300,
					mainClass: "mfp-fade",
					items: [
						{
							type: "inline",
							src: result,
						},
					],
				});
			},
		});
	});
	$doc.on("click", ".btn-close", function(e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
	$(".accordion").on("click", ".accordion__head", function() {
		$(this)
			.closest(".accordion")
			.toggleClass("active")
			.find(".accordion__body")
			.slideToggle()
			.closest(".accordion")
			.siblings()
			.removeClass("active")
			.find(".accordion__body")
			.slideUp();
	});
	$doc.on("click", ".up, .down", function(e) {
		e.stopPropagation();

		var $button = $(this);
		var $input = $button.parent().find(".qty");
		var value = Number($input.val()) || 0;
		var step = Number($input.attr("step")) || 1;
		var min = Number($input.attr("min")) || 0;
		var max = Number($input.attr("max"));

		if ($button.hasClass("up")) {
			value += step;
		} else {
			value -= step;
		}

		if (min > value) {
			value = min;
		} else if (value > max && max > 0) {
			value = max;
		}

		$input.val(value).trigger("change");

		e.preventDefault();
	});

	$doc.on('change', '.variations_form .variations select', function(e) {
		set_product_variation_image($(this).val());
	});

	$doc.on("click", ".js-popup-custom", function(e) {
		e.preventDefault();
		$($(this).data("target")).toggleClass("visible-popup");
	});
	$(".btn-burger").on("click", function(e) {
		e.preventDefault();
		$(this).toggleClass("active");
		$(".header").toggleClass("active");
		$(".nav .open").removeClass("open");
		$("body").removeClass("sub-menu-open");

		if ($(".header").hasClass("active")) {
			scrollOnOpen = $win.scrollTop();
			$(".wrapper").css({ top: -scrollOnOpen });
		} else {
			$(".wrapper").css({ top: 0 });
			$("html, body").scrollTop(scrollOnOpen);

			scrollOnOpen = null;
		}
	});
	$(".js-back").on("click", function(e) {
		e.preventDefault();
		$("body").removeClass("sub-menu-open");
		$(".nav .open").removeClass("open");
	});
	$(".js-close").on("click", function(e) {
		e.preventDefault();
		$(".nav .open").removeClass("open");
		$("body").removeClass("sub-menu-open");
		$(".header").removeClass("active");
	});
	$(".product-secondary").on("click", function(e) {
		e.preventDefault();
		$(this)
			.addClass("expanded")
			.closest(".form__col")
			.siblings()
			.find(".product-secondary")
			.removeClass("expanded");
	});
	$doc.on("click touchstart", function(e) {
		var $target = $(e.target);
		if (!$target.closest(".product-secondary").length) {
			$(".product-secondary").removeClass("expanded");
		}
	});
	$(".nav a:not(.js-back):not(.js-close)").on("click", function(e) {
		if ($win.width() < 1025) {
			var $parent = $(this).parent();
			var $siblingUl = $parent.find(" > .dropdown");
			if ($siblingUl.length && !$parent.hasClass("open")) {
				$("body").addClass("sub-menu-open");
				$parent
					.addClass("open")
					.siblings()
					.removeClass("open")
					.find(".open")
					.removeClass("open");
				e.preventDefault();
			}
		}
	});
	$(".popup").scrollLock();
	$win.on("load", function() {
		startMaps();
		animateElements();
		animate(scrolledY);
		removeMessages();
		if ($(".accordion.expanded").length) {
			$(".accordion.expanded .accordion__body").slideDown();
		}
		$(".slider-alt .slider__slides").slick({
			slidesToShow: 7,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5,
						dots: true,
					},
				},
				{
					breakpoint: 1023,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4,
						dots: true,
					},
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
					},
				},
			],
		});

		$(".slider-story .slider__slides").slick({
			slidesToShow: 1,
			adaptiveHeight: true,
			infinite: true
		});

		// Product variation image
		if ( $('.variation__image').length ) {
			var activeVariation = $('.variations_form .variations select').val();	
			set_product_variation_image(activeVariation);
		}
	})
		.on("load scroll", function() {
			scrolledY = $win.scrollTop();
			if (scrolledY > $(".header").outerHeight()) {
				$(".header").addClass("fixed");
			} else {
				$(".header").removeClass("fixed");
			}
		})
		.on("scroll", function() {
			scrolledY = $win.scrollTop();
			animate(scrolledY);
		})
		.on("load resize", function() {
			if (isMobile()) {
				if (
					!$(".slider-products-mobile").hasClass("slick-initialized")
				) {
					$(".slider-products-mobile").slick({
						slidesToShow: 3,
						slidesToScroll: 3,
						centerMode: true,
					});
				}
			} else {
				if (
					$(".slider-products-mobile").hasClass("slick-initialized")
				) {
					$(".slider-products-mobile").slick("unslick");
				}
			}
		});
	// Pop Plan
	if ($("#app").length) {
		new Vue({
			el: "#app",
			data: {
				error: false,
				total: 0,
				frequency: "",
				products: crb_options.products,
				checkoutError: false,
				checkoutSuccess: false,
				frequencyError: false,
			},
			methods: {
				prepareCheckout: function() {
					var vm = this;
					$("body").addClass("loading");
					$.ajax({
						type: "POST",
						url:
							crb_options.admin_ajax_url +
							"?action=prepare_checkout",
						data: {
							products: JSON.stringify(vm.products),
						},
						success: function(response) {
							$("body").removeClass("loading");
							if (response.success) {
								vm.checkoutError = false;
								vm.checkoutSuccess = true;
								window.location.href = response.redirect_url;
							} else {
								vm.checkoutError = true;
							}
						},
					});
				},
				quantityIncrement: function(index) {
					if (this.total === 12) {
						return;
					}
					this.products[index].qty++;
					this.total++;
				},
				quantityDecrement: function(index) {
					if (this.products[index].qty === 0) {
						return;
					}
					this.products[index].qty--;
					this.total--;
				},
			},
			mounted: function() {
				initProducts();
			},
		});
	}
	// Update Cart
	function updateCart(openPopup){
		$.ajax({
			url: window.location.href,
			type: "GET",
			success: function(response) {
				var newCart = $(response)
					.find(".popup")
					.html();
				$(".popup").html(newCart);
				$('#popup-cart').addClass('visible-popup');
			},
		});
	}

	$doc.on("click", 'button[name^="update_cart"]', function() {
		setTimeout(function() {
			updateCart(false);
		}, 500);
	});
	$doc.on("change", ".widget-cart .qty", function(e) {
		$(".widget-cart button.button").attr("disabled", false);
	});
	$doc.bind('submit', function(event) {
		if(!$(event.target).hasClass('cart')) {
			return;
		}

		var currentQuantity = $('.btn-cart span').text();
		var addedQuantity = $(event.target)
			.find('.qty')
			.val();

		$('.btn-cart span').text(parseInt(currentQuantity) + parseInt(addedQuantity));
	});
	$body.on('added_to_cart', function(result){
		if(result){
			updateCart(true);
		}
	});
})(window, document, window.jQuery);
